/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { RoutePath } from 'shared/enums/RoutePath';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';
import history from '../../../../history';
import { keycloakService } from '../../auth/auth.service';
import { postSignOutThunk } from '../../auth/auth.thunk';

/* Thunks */
export const removeUserFromOrg = createFOAsyncThunk('removeUser/removeFromOrg', async (args) => {
  return userApi.removeUserFromOrganization(args.userId, args.orgId);
});

export const deleteValidateRemoveUserThunk = createFOAsyncThunk(
  'removeUser/validateRemoveUserAccount',
  async (args, { rejectWithValue }) => {
    try {
      return await userApi.removeUser(args.userId, 'true');
    } catch (error) {
      if (error.response && error.response.status === 412) {
        const { data } = error.response;
        return rejectWithValue({ showAlert: false, data });
      }
      throw error;
    }
  },
);

export const deleteRemoveUserAccountThunk = createFOAsyncThunk('removeUser/removeUserAccount', async (args) => {
  return userApi.removeUser(args.userId, 'false');
});

export const postDeleteUserAccountRejectedThunk = createFOAsyncThunk(
  'removeUser/postDeleteUserAccountRejected',
  async (organizationId) => {
    history.replace(RoutePath.generateRoutePath(RoutePath.USER_SEARCH, { organization: organizationId }));
  },
);

export const postDeleteUserAccountThunk = createFOAsyncThunk('removeUser/postRemoveUserAccount', async (thunkApi) => {
  await keycloakService.logout();
  thunkApi.dispatch(postSignOutThunk());
});
